const Pubs = () => {
    return (
        <div className="pubsAndSocials">
            <text>
                <p>Fiction:</p>
                <ul>
                    <li className="bullet">
                        "Dreams," a short story in&nbsp;
                        <a className="link" href="https://theseventhwave.org/publications/community-anthologies/" target="_blank" rel="noopener noreferrer">
                            <i>The Seventh Wave</i>
                        </a>{" "}
                        (forthcoming)
                    </li>
                    <li className="bullet">
                        "A Precious Stone," a short story in&nbsp;
                        <a className="link" href="https://magazine.catapult.co/fiction/stories/amy-y-q-lin-fiction-short-story-a-precious-stone" target="_blank" rel="noopener noreferrer">
                            <i>Catapult</i>
                        </a>{" "}
                        (Dec 2022)
                    </li>
                </ul>
                <p>Interviews:</p>
                <ul>
                    <li className="bullet">
                        "The Body and Other Sites of Resistance" with Sarah Wang in&nbsp;
                        <a className="link" href="https://lareviewofbooks.org/article/new-skin-sarah-wang-plastic-surgery-immigrant-novel/" target="_blank" rel="noopener noreferrer">
                            <i>Los Angeles Review of Books</i>
                        </a>
                        &nbsp;(May 2026)
                    </li>
                    <li className="bullet">
                        "On Working Through Discomfort" with M Lin in&nbsp;
                        <a className="link" href="https://thecreativeindependent.com/people/writer-m-lin-on-working-through-discomfort" target="_blank" rel="noopener noreferrer">
                            <i>The Creative Independent</i>
                        </a>
                        &nbsp;(May 2026)
                    </li>
                    <li className="bullet">
                        "Very Little of This Book Is Made-up: Talking with R.F. Kuang about her Novel" in&nbsp;
                        <a
                            className="link"
                            href="https://therumpus.net/2023/05/17/very-little-of-this-book-is-made-up-talking-with-r-f-kuang-about-her-novel/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i>The Rumpus</i>
                        </a>
                        &nbsp;(May 2023)
                    </li>
                    <li className="bullet">
                        "Accessing the Truth: An Interview with Josh Riedel" in&nbsp;
                        <a className="link" href="https://one-story.com/2023/03/16/accessing-the-truth-an-interview-with-josh-riedel/" target="_blank" rel="noopener noreferrer">
                            <i>One Story</i>
                        </a>
                        &nbsp;(Mar 2023)
                    </li>
                </ul>
                <p>Criticism:</p>
                <ul>
                    <li className="bullet">
                        "'This Is Not a Drill': Maggie Nelson's New Book, <i>The Slicks</i>," a book review in&nbsp;
                        <a className="link" href="https://therumpus.net/2026/01/27/this-is-not-a-drill-maggie-nelsons-new-book-the-slicks/" target="_blank" rel="noopener noreferrer">
                            <i>The Rumpus</i>
                        </a>
                        &nbsp;(Jan 2026)
                    </li>
                    <li className="bullet">
                        "<i>In This Corner of the World</i> is a Simple, Perfect Exhibit of Life," a film review in&nbsp;
                        <a className="link" href="https://cornellsun.com/2017/11/05/in-this-corner-of-the-world-is-a-simple-perfect-exhibit-of-life/" target="_blank" rel="noopener noreferrer">
                            <i>The Cornell Daily Sun</i>
                        </a>{" "}
                        (Nov 2017)
                    </li>
                    <li className="bullet">
                        "Not Strange At All," a music review in&nbsp;
                        <a className="link" href="https://cornellsun.com/2016/08/30/not-strange-at-all/" target="_blank" rel="noopener noreferrer">
                            <i>The Cornell Daily Sun</i>
                        </a>{" "}
                        (Aug 2016)
                    </li>
                    <li className="bullet">
                        "<i>Stardew Valley</i>: Pushing The Boundaries of Farming RPGs," a video game review in&nbsp;
                        <a className="link" href="https://cornellsun.com/2016/02/23/stardew-valley-pushing-the-boundaries-of-farming-rpgs/" target="_blank" rel="noopener noreferrer">
                            <i>The Cornell Daily Sun</i>
                        </a>{" "}
                        (Feb 2016)
                    </li>
                    <li className="bullet">
                        "Appreciating Miyazaki: Insight Into a Master's World," a film review in <i>The Cornell Daily Sun</i> (Jan 2015)
                    </li>
                    <li className="bullet">
                        "A Lost French Classic Remembered," a film review in <i>The Cornell Daily Sun</i> (Jan 2015)
                    </li>
                    <li className="bullet">
                        "Movie Review: <i>The Maze Runner</i>," a film review in <i>The Cornell Daily Sun</i> (2014)
                    </li>
                    <li className="bullet">
                        "Spinning Singles," a music review in <i>The Cornell Daily Sun</i> (2014)
                    </li>
                    <li className="bullet">
                        "<i>Cover Boy</i>: An Uncensored Observation on LGBTQ Struggles," a dance review in <i>The Cornell Daily Sun</i> (2014)
                    </li>
                </ul>
                <p>Journalism:</p>
                <ul>
                    <li className="bullet">
                        "Interview with Factor, RQ Hartford Winner and Best of Master Yi" in{" "}
                        <a className="link" href="https://piltoverarchive.com/news/interview-with-factor" target="_blank" rel="noopener noreferrer">
                            Piltover Archive
                        </a>{" "}
                        (July 2026)
                    </li>
                    <li className="bullet">
                        "Dos and Don'ts of Tournament Play," a satire piece in{" "}
                        <a className="link" href="https://piltoverarchive.com/news/dos-and-donts-of-tournament-play" target="_blank" rel="noopener noreferrer">
                            Piltover Archive
                        </a>{" "}
                        (June 2026)
                    </li>
                    <li className="bullet">
                        "Interview with Sehnbon, Best Of Broker" in{" "}
                        <a className="link" href="https://piltoverarchive.com/news/interview-with-sehnbon-best-of-broker" target="_blank" rel="noopener noreferrer">
                            Piltover Archive
                        </a>{" "}
                        (May 2026)
                    </li>
                    <li className="bullet">
                        "Exclusive: RQ Houston Champion Miss Fortune card sells for $100,000," a feature in{" "}
                        <a className="link" href="https://piltoverarchive.com/news/exclusive-miss-fortune-card-sells-for-100-000" target="_blank" rel="noopener noreferrer">
                            Piltover Archive
                        </a>{" "}
                        (Apr 2026)
                    </li>
                    <li className="bullet">
                        "Interview with GhaelWinds, Houston's Best Of Yasuo" in{" "}
                        <a className="link" href="https://piltoverarchive.com/news/interview-with-ghaelwinds-houston-s-best-of-yasuo" target="_blank" rel="noopener noreferrer">
                            Piltover Archive
                        </a>{" "}
                        (Apr 2026)
                    </li>
                    <li className="bullet">
                        "Literary Roundup: Washington Square Review's 2022 Staff Picks," a listicle in{" "}
                        <a
                            className="link"
                            href="https://www.washingtonsquarereview.com/online-exclusives/2023/1/1/washington-square-reviews-2022-staff-picks"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i>Washington Square Review</i>
                        </a>{" "}
                        (Jan 2023)
                    </li>
                </ul>
                <p>Content Marketing:</p>
                <ul>
                    <li className="bullet">
                        "Video Game Testers Hiring Guide," an article in{" "}
                        <a className="link" href="https://www.toptal.com/video-game-testers#hiring-guide" target="_blank" rel="noopener noreferrer">
                            Toptal's Engineering Blog
                        </a>{" "}
                        (Sep 2024)
                    </li>
                    <li className="bullet">
                        Copy for{" "}
                        <a className="link" href="https://www.toptal.com/web" target="_blank" rel="noopener noreferrer">
                            Web
                        </a>{" "}
                        and{" "}
                        <a className="link" href="https://www.toptal.com/react" target="_blank" rel="noopener noreferrer">
                            React
                        </a>{" "}
                        pages in Toptal's Engineering Blog (Aug 2024)
                    </li>
                    <li className="bullet">"Going Serverless: Benefits and Considerations," an article in Toptal's Engineering Blog (May 2024)</li>
                </ul>
            </text>
            <br />
        </div>
    );
};

export default Pubs;
